import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@assets/css/base.css";
import "@assets/css/reset.css";
import "@assets/css/style.css";
import "@assets/js/default";

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$ = window.$;
Vue.prototype.tns = window.tns;
Vue.prototype.isMobile = window.isMobile;
Vue.prototype.LtPhoneLogin = window.LtPhoneLogin;

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
